import React, { useState } from 'react';
import __ from 'localisation';
import Heading from '@hubins/components/Heading';
import Modal from '@hubins/components/Modal';
import Button, { ButtonWrap } from '@hubins/components/Button';
import { useAuth } from '../../contexts/AuthContext';
import './index.scss';

const Dashboard = () => {
  const { user } = useAuth();
  const tfa = user.tfa;

  const [tfaAlert, setTfaAlert] = useState(!tfa);

  const closeTfaAlert = () => {
    setTfaAlert(false);
  };

  return (
    <>
      {!tfa && (
        <Modal
          open={tfaAlert}
        >
          <Heading size="3">
            {__('tfa_required_title')}
          </Heading>
          <p>{__('tfa_required_text')}</p>
          <p>{__('tfa_required_text_2')}</p>
          <ButtonWrap center>
            <Button href="/dashboard/settings" className="cta">
              {__('settings')}
            </Button>
            <Button onClick={closeTfaAlert}>
              {__('do_later')}
            </Button>
          </ButtonWrap>
        </Modal>
      )}
    </>
  );
};

export default Dashboard;
